<template lang="html">
  <div class="col-12 col-lg-8 col-form">
    <div class="box-action">
      <router-link class="link-back" to="/"><i class="fal fa-chevron-left icon"></i> <span>Regresar</span></router-link>
    </div>

    <div class="box-form">
      <h6 class="simple-title">¿Olvidaste tu contraseña?</h6>

      <p class="mt-3">
        Escribe tu correo y te envíaremos las instrucciones de recuperación <br />de contraseña.
      </p>

      <b-form class="form" @submit="onSubmit">
        <b-form-group class="custom-form-group"
          label="Correo"
          label-for="il-email">
          <b-form-input
            id="il-email"
            v-model="form.email"
            type="email"
            placeholder="correo@ejemplo.com"
            required
          ></b-form-input>
        </b-form-group>

        <p class="mt-5 pt-4">
          <b-button type="submit" class="btn _btn-st1 btn-orange">Enviar correo</b-button>
        </p>

        <p class="mt-4">
          ¿Nuevo aqui? <router-link class="link-green" to="/registrarse">Crear una cuenta nueva</router-link>
        </p>
      </b-form>

    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        email: null
      }
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault()
    }
  }
}
</script>
